<template>
<v-container>
  <v-row no-gutters v-if="is_required == false">
    <v-col 
          cols="auto"
          class="ml-auto mb-1">
      <v-btn text small @click="skip" :style="{color: bot_setting.main_color}">Skip »</v-btn>
    </v-col>
  </v-row>
  <v-row no-gutters justify="center" align="center">
    <v-col 
      lg="6"
      md="6"
      sm="12"
      xs="12"
      class="ml-auto mr-auto">
      <v-row>
        <v-select class="pr-2"
            v-model="selectedData"
            :items="selection_options"
            item-text="title"
            item-value="value"
            :label="placeholder"
            :error-messages="!checkValid ? error_message_2: ''"
            return-object
            chips
            multiple
            solo
        ></v-select>
    </v-row>
    </v-col>
  </v-row>
  <v-row no-gutters justify="center" align="center">
    <v-btn dark @click="submit" :style="{backgroundColor: bot_setting.main_color}">次へ</v-btn>
  </v-row>

</v-container>
</template>

<style>
.custom-checkbox .v-messages{
  display:none;
}
</style>


<script>
import utils from '@/utils/utils.js'

export default {

  name: "DropdownMultiInput",

  props: ['placeholder', 'error_message', 'bot_setting', 'is_required', 'selection_options', 'label_name', 'question_id', 'answer_data', 'custom_validation'],

  created(){
    this.checkValid = true
    this.error_message_2 = this.error_message
  },

  data: () =>({
    selectedData:[],
    checkValid: true,
    //error_message: 'Please select an option',
    error_message_2: ''
  }),


  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },

    submit(){
      this.checkValid = true
      this.error_message_2 = this.error_message

      var emitValue = {user_chat_message: '', user_chat_value:''}

      for(var i=0; i< this.selectedData.length; i++){
        var item = this.selectedData[i]
          emitValue.user_chat_message += item.title + ','
          emitValue.user_chat_value += item.value + ','
      }

      if (this.selectedData.length == 0){
        this.checkValid = false
        return false
      }
      

      if (this.selectedData.length > 0 && emitValue.user_chat_message.length > 1)
        emitValue.user_chat_message = emitValue.user_chat_message.substring(0, emitValue.user_chat_message.length - 1);

      if (this.selectedData.length > 0 && emitValue.user_chat_value.length > 1)
        emitValue.user_chat_value = emitValue.user_chat_value.substring(0, emitValue.user_chat_value.length - 1);

      if (this.customValidation(emitValue.user_chat_value) == false){
        this.checkValid = false
        return false
      }else{
        this.$emit('dropdown_multi_input_submitted', emitValue)
      }
      
    },

    customValidation(_input_value){
      if (this.custom_validation.length > 0){
        this.error_message_2 = ''
        var temp_answer_data = JSON.parse(JSON.stringify(this.answer_data))
        temp_answer_data.push({ 'key': this.label_name, 'value': _input_value, 'question_id': this.question_id })

        for(var j=0; j < this.custom_validation.length; j++){
          if (this.custom_validation[j].rule != ''){
            var validation_result = utils.runCustomValidation(this.custom_validation[j].rule, temp_answer_data)
            if (validation_result == false){
              this.error_message_2 = this.custom_validation[j].error_message
              return false
            }
          }
        }
      }
      return true
    }

  },
  watch:{
    // selectedData: function(){
    //   if (this.selectedData.length > 0){
    //     this.checkValid = true
    //   }
    // }
  }

}
</script>